import { Box } from '@mui/material';
import TooltipHardened from '../TooltipHardened';
import React, { useMemo } from 'react';
import { InputActionProps, InputAdditions, InputCollapsibleProps } from './InputAdditions';

interface Props {
  label: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
  action?: InputActionProps;
  collapsible?: InputCollapsibleProps;
}

export default function StyledTextItem({ label, tooltip, disabled, action, collapsible }: Props): React.JSX.Element {
  const isDisabled = !!disabled;

  const content = useMemo(
    () => (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        sx={{
          width: '100%',
          height: 56,
          borderRadius: 1,
          borderTopLeftRadius: action?.side === 'left' ? 0 : 1,
          borderBottomLeftRadius: action?.side === 'left' ? 0 : 1,
          borderTopRightRadius: action?.side === 'right' ? 0 : 1,
          borderBottomRightRadius: action?.side === 'right' ? 0 : 1,
          border: 1,
          borderColor: isDisabled ? 'text.primary' : 'text.secondary',
        }}
      >
        <TooltipHardened tooltip={tooltip}>
          <>{label}</>
        </TooltipHardened>
      </Box>
    ),
    [label, action?.side, tooltip, isDisabled],
  );

  return (
    <InputAdditions action={action} collapsible={collapsible}>
      {content}
    </InputAdditions>
  );
}
